import { SelectOption } from 'components/Select'
import { Workspace } from 'features/workspace'
import { WorkspaceSlice } from './types'

export const toSelectOptions = (workspaces: WorkspaceSlice[]): SelectOption<WorkspaceSlice>[] =>
  workspaces.map(
    (workspace: WorkspaceSlice): SelectOption<WorkspaceSlice> => ({
      label: workspace.name,
      rawData: {
        ...workspace,
      },
      value: workspace.id,
    }),
  )

export const initialOptions = (
  workspacesOptions: SelectOption<WorkspaceSlice>[],
  currentWorkspaceId?: Workspace['id'],
): SelectOption<WorkspaceSlice> => {
  if (currentWorkspaceId) {
    const userWorkspaceOption: SelectOption<WorkspaceSlice> | undefined = workspacesOptions.find(
      (workspace: SelectOption<WorkspaceSlice>): boolean => workspace.value === currentWorkspaceId,
    )

    if (userWorkspaceOption === undefined) {
      throw Error('Mismatched Workspace IDs')
    }
    return userWorkspaceOption
  } else {
    return workspacesOptions[0]
  }
}

export const toOptionProps = (workspaceOption: SelectOption<WorkspaceSlice>): WorkspaceSlice => {
  const { label, rawData: workspace, value } = workspaceOption

  if (workspace === undefined) {
    throw Error('Workspace should be fetched and accessible')
  }

  const { alerts, networkCode } = workspace

  return {
    alerts: alerts,
    id: value,
    name: label,
    networkCode,
  }
}
